var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.auctions.count == 0 ? _c('div', [_vm._v("No active auctions")]) : _vm._e(), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "dataSource": _vm.auctions
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function fn(text, record) {
        return _c('router-link', {
          attrs: {
            "to": '/auctions/' + record.id + '/live'
          }
        }, [_c('a', {
          staticClass: "btn btn-sm btn-light",
          attrs: {
            "href": "javascript: void(0);"
          }
        }, [_vm._v(_vm._s(text))])]);
      }
    }, {
      key: "status",
      fn: function fn(text) {
        return _c('span', {
          class: _vm.statusClasses(text)
        }, [_vm._v(_vm._s(text))]);
      }
    }, {
      key: "action",
      fn: function fn(record) {
        return _c('span', {}, [_c('a-space', {
          attrs: {
            "space": 16
          }
        }, [_c('router-link', {
          attrs: {
            "to": '/auctions/' + record.id + '/live'
          }
        }, [_c('a-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          }
        }, [_c('i', {
          staticClass: "fe fe-arrow-up-right mr-2"
        }), _vm._v(" Open ")])], 1)], 1)], 1);
      }
    }, {
      key: "startsAt",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v(_vm._s(_vm.moment(text).format('DD/MM/YYYY HH:mm')))]);
      }
    }, {
      key: "endsAt",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v(_vm._s(_vm.moment(text).format('DD/MM/YYYY HH:mm')))]);
      }
    }])
  })], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Announced or active auctions")])]);
}]

export { render, staticRenderFns }